import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
// import { DateTime } from "luxon";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  CardBody,
  CardFooter,
  Modal,
  Table,
} from "reactstrap";

import {
  passkeyAssertion,
  getPasskeyJWTAsync,
} from "../../../../webauthn/securityStepUp";

import styled from "styled-components";

import PresentationNavbar from "../../../../components/Navbars/PresentationNavbar";

const TopRightCircleWrapper = styled.div`
  z-index: 5;

  position: absolute;
  @media only screen and (min-width: 768px) {
    width: 350px;
    height: 350px;
    max-width: 20rem;

    top: -150px;
    right: -120px;
  }
  @media only screen and (max-width: 767px) {
    width: 300px;
    height: 300px;
    max-width: 10rem;

    top: -100px;
    right: -100px;
  }
`;

const CirclePink = styled.div`
  width: 100%;
  height: 100%;
  max-height: none;
  max-width: none;

  filter: blur(50px);
  background-color: rgba(234, 85, 237, 0.8);
  border-radius: 100%;
  flex: none;
  transform: translate(-100px);
`;

const CircleBlue = styled.div`
  width: 100%;
  height: 100%;
  max-height: none;
  max-width: none;

  position: relative;

  @media only screen and (min-width: 768px) {
    top: -200px;
    filter: blur(50px);
    transform: translate(75px);
  }
  @media only screen and (max-width: 767px) {
    top: -150px;
    filter: blur(45px);
  }
  mix-blend-mode: multiply;
  background-color: #84caff;
  border-radius: 100%;
  flex: none;
`;

const EntityProfitLossStatement = () => {
  const params = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const passkeyEmail = searchParams.get("email");

  const presentationLegalEntity = params.legalEntityUUID;

  /*
  const [presentationPasskeyModalIsOpen, setPresentationPasskeyModalIsOpen] =
    useState(false);

  useEffect(() => {
    // FOR TESTING!!!
    (async () => {
      const response = await fetch(
        `${process.env.REACT_APP_ACCOUNTEDFOR_API_URL}/passkey/report/profit-loss`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await getPasskeyJWTAsync()}`,
            "x-principal-legal-entity-uuid": presentationLegalEntity,
          },
        }
      );

      if (response.ok) {
        setPresentationPasskeyModalIsOpen(false);

        const json = await response.json();

        setProfitLossReport(json.report);
      } else {
        alert("❌ Error Retrieving Report Data");
      }
    })();
  }, [setProfitLossReport]);
  */
  const [presentationPasskeyModalIsOpen, setPresentationPasskeyModalIsOpen] =
    useState(true);

  const [profitLossReport, setProfitLossReport] = useState();

  const boom = async () => {
    const result = await passkeyAssertion({ email: passkeyEmail });

    if (result.status === "ok") {
      const response = await fetch(
        `${process.env.REACT_APP_ACCOUNTEDFOR_API_URL}/passkey/report/profit-loss`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await getPasskeyJWTAsync()}`,
            "x-principal-legal-entity-uuid": presentationLegalEntity,
          },
        }
      );

      if (response.ok) {
        setPresentationPasskeyModalIsOpen(false);

        const json = await response.json();

        setProfitLossReport(json.report);
      } else {
        alert("❌ Error Retrieving Report Data");
      }
    } else {
      alert(
        "Unable to find or use Passkey. Contact accountedfor on 1300 201 329"
      );
    }
  };

  return (
    <>
      <Modal
        isOpen={presentationPasskeyModalIsOpen}
        toggle={() => false}
        size="md"
        className="modal-dialog-centered"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Your Profit & Loss Statement is Protected
          </h5>
        </div>
        <div className="modal-body">
          <h6>Your Financial Report is Now Ready</h6>
          <p>
            To view the financial report for this entity, you must have an
            accountedfor Passkey and be authorised to view Profit & Loss
            statements.
          </p>
          <small>
            You can obtain an accountedfor Passkey by{" "}
            <a href="/register">Registering with accountedfor</a>.
          </small>
        </div>
        <div className="modal-footer">
          <Button
            color="success"
            data-dismiss="modal"
            type="button"
            onClick={() => boom()}
          >
            Sign In With Passkey
          </Button>
        </div>
      </Modal>
      <PresentationNavbar
        reportName={profitLossReport?.report_name ?? "Financial Report"}
      />
      <Container>
        <TopRightCircleWrapper>
          <CirclePink />
          <CircleBlue />
        </TopRightCircleWrapper>
        <Card className="text-left shadow border-1 mb-5" style={{ zIndex: 15 }}>
          <CardBody className="p-4">
            <Row>
              <Col xs="12">
                <h4 className="text-left">
                  {profitLossReport?.draft ? "Draft" : ""} Profit & Loss
                </h4>
                <p>
                  {profitLossReport?.entity_name}
                  <br />
                  {profitLossReport?.period_label}
                </p>
              </Col>
            </Row>
            <Table className="align-items-center table-flush" responsive>
              <tbody>
                <tr>
                  {profitLossReport ? (
                    profitLossReport.period_groups.map(
                      (period_group, index) => (
                        <td
                          key={index}
                          colSpan={index === 0 ? 2 : 1}
                          className="text-right"
                        >
                          {period_group ?? "-"}
                        </td>
                      )
                    )
                  ) : (
                    <td className="text-right" colSpan={2}>
                      -
                    </td>
                  )}
                </tr>
                <tr>
                  <td
                    className="pl-0 pt-0 pb-0"
                    colSpan={profitLossReport?.period_groups.length}
                  >
                    <b>Trading Income</b>
                  </td>
                  <td className="text-right"></td>
                </tr>
                {profitLossReport?.income_items.map((income_item, index) => (
                  <tr key={index}>
                    <td className="pl-3 pt-1 pb-1">{income_item.label}</td>
                    {income_item.amounts.map((amount, index) => (
                      <td key={index} className="text-right pt-0 pb-0">
                        {new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(amount)}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td className="pl-3 pt-1 pb-1">
                    <b>Total Trading Income</b>
                  </td>
                  {profitLossReport ? (
                    profitLossReport.income_totals.map(
                      (income_total, index) => (
                        <td key={index} className="text-right pt-0 pb-0">
                          <b>
                            {new Intl.NumberFormat("en-AU", {
                              style: "currency",
                              currency: "AUD",
                            }).format(income_total)}
                          </b>
                        </td>
                      )
                    )
                  ) : (
                    <td className="text-right pt-0 pb-0">
                      <b>-</b>
                    </td>
                  )}
                </tr>
                <tr>
                  <td
                    className="pl-0 pt-0 pb-0"
                    colSpan={profitLossReport?.period_groups.length}
                  >
                    <b>Operating Expenses</b>
                  </td>
                  <td className="text-right"></td>
                </tr>
                {profitLossReport?.expense_items.map((expense_item, index) => (
                  <tr key={index}>
                    <td className="pl-3 pt-1 pb-1">{expense_item.label}</td>
                    {expense_item.amounts.map((amount, index) => (
                      <td key={index} className="text-right pt-0 pb-0">
                        {new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(amount)}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td className="pl-3 pt-1 pb-1">
                    <b>Total Operating Expenses</b>
                  </td>
                  {profitLossReport ? (
                    profitLossReport.expense_totals.map(
                      (expense_total, index) => (
                        <td key={index} className="text-right pt-0 pb-0">
                          <b>
                            {new Intl.NumberFormat("en-AU", {
                              style: "currency",
                              currency: "AUD",
                            }).format(expense_total)}
                          </b>
                        </td>
                      )
                    )
                  ) : (
                    <td className="text-right pt-0 pb-0">
                      <b>-</b>
                    </td>
                  )}
                </tr>
                <tr>
                  <td className="pl-0 pt-1 pb-1">
                    <b>Net Profit</b>
                  </td>
                  {profitLossReport ? (
                    profitLossReport.net_profits.map((net_profit, index) => (
                      <td key={index} className="text-right pt-1 pb-1">
                        <b>
                          {new Intl.NumberFormat("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          }).format(net_profit)}
                        </b>
                      </td>
                    ))
                  ) : (
                    <td className="text-right pt-0 pb-0">
                      <b>-</b>
                    </td>
                  )}
                </tr>
                <tr>
                  <td
                    className="pl-0 pt-0 pb-0"
                    colSpan={profitLossReport?.period_groups.length}
                  ></td>
                  <td className="text-right"></td>
                </tr>
              </tbody>
            </Table>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </CardBody>
          <CardFooter>
            <Row>
              <Col xs="12" className={"text-right"}>
                <Button
                  color="primary"
                  onClick={() => alert("Coming Soon!")}
                  size="md"
                >
                  Download PDF
                </Button>
              </Col>
            </Row>
          </CardFooter>
        </Card>
      </Container>

      <br />
      <p className="text-center">
        {profitLossReport?.preparation_details_line1}
      </p>
      <p className="text-center">
        {profitLossReport?.preparation_details_line2}
      </p>
      <br />
      <br />
      <p className="text-center mb-0">
        Powered by{" "}
        <a href="https://www.accountedfor.com.au">accountedfor.com.au</a>.
      </p>
      <p className="text-center">We've got your whole business accountedfor.</p>
      <br />
      <br />
    </>
  );
};

export default EntityProfitLossStatement;
